import { gql } from 'apollo-boost'
import { GrantPlusSubscription, GrantPlusSubscriptionVariables } from './__generated__/GrantPlusSubscription'
import { useMutation } from '@apollo/react-hooks'

const GRANT_PLUS_SUBSCRIPTION_MUTATION = gql`
  mutation GrantPlusSubscription($boardId: String!) {
    grantPlusSubscriptionV2(boardId: $boardId) {
      ... on PlusSubscriptionV2 {
        id
        subscriptionId
        paymentProvider
      }
      ... on PlusSubscriptionErrorV2 {
        error
        type
      }
    }
  }
`

export const useGrantPlusSubscription = () => {
  return useMutation<GrantPlusSubscription, GrantPlusSubscriptionVariables>(GRANT_PLUS_SUBSCRIPTION_MUTATION)
}
